import { Injectable, Inject, Directive, ElementRef, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CdnConfig {
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CdnService {
    /**
     * @param {?} cdnConfigValues
     */
    constructor(cdnConfigValues) {
        this.cdnConfigValues = cdnConfigValues;
        this.cdnList = [];
        this.nameMapping = {};
        this.addCDNUrl = (/**
         * @param {?} cdnBaseUrl
         * @return {?}
         */
        (cdnBaseUrl) => {
            this.cdnList.push(cdnBaseUrl);
        });
        this.cdnList = cdnConfigValues.cdnList;
        this.nameMapping = cdnConfigValues.nameMapping;
    }
    /**
     * @param {?} url
     * @return {?}
     */
    getCDNUrl(url) {
        if (this.cdnList.length === 0) {
            return url;
        }
        // do not process full URLs
        if (/^https?:\/\//.test(url)) {
            return url;
        }
        url = this.stripLeadingSlash(url);
        /** @type {?} */
        const cdnIndex = (url.length) % (this.cdnList.length);
        /** @type {?} */
        const cdnPrefix = this.stripTrailingSlash(this.cdnList[cdnIndex]);
        // apply mapping
        /** @type {?} */
        const mappingFor = this.nameMapping;
        /** @type {?} */
        const mappedUrl = mappingFor[url] || url;
        url = `${cdnPrefix}/${mappedUrl}`;
        return url;
    }
    /**
     * @private
     * @param {?} url
     * @return {?}
     */
    stripTrailingSlash(url) {
        return url.replace(/\/$/, '');
    }
    /**
     * @private
     * @param {?} url
     * @return {?}
     */
    stripLeadingSlash(url) {
        return url.replace(/^\//, '');
    }
}
CdnService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
CdnService.ctorParameters = () => [
    { type: CdnConfig, decorators: [{ type: Inject, args: ['CDN_CONFIG_VALUES',] }] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CdnDirective {
    /**
     * @param {?} _cdnService
     * @param {?} _el
     */
    constructor(_cdnService, _el) {
        this._cdnService = _cdnService;
        this._el = _el;
        this.element = _el.nativeElement;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.element.src = this._cdnService.getCDNUrl(this.source);
    }
}
CdnDirective.decorators = [
    { type: Directive, args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[wdpr-ra-angular-cdn]',
                providers: [CdnService]
            },] }
];
/** @nocollapse */
CdnDirective.ctorParameters = () => [
    { type: CdnService },
    { type: ElementRef }
];
CdnDirective.propDecorators = {
    source: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
const ɵ0 = {
    cdnList: [],
    nameMapping: {
        url: undefined
    }
};
class CdnModule {
}
CdnModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                providers: [
                    CdnService,
                    {
                        provide: 'CDN_CONFIG_VALUES',
                        useValue: ɵ0
                    },
                ],
                declarations: [CdnDirective],
                exports: [CdnDirective]
            },] }
];

export { CdnConfig, CdnDirective, CdnModule, CdnService };
//# sourceMappingURL=wdpr-ra-angular-cdn.js.map
